module.exports = __webpack_public_path__ + "media/images/lb/848-0b77ad7653bec8d6e1720c0a0765ee7d.svg";